export default "__VITE_ASSET__C0zqo0dW__"